<template> 
<div :style="mapSize()">
    <br>
   <!-- <div id="myMap" :style="mapSize()"></div> -->
   <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7742.440552326866!2d33.7849863!3d-14.0049491!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1921d30ce134cfab%3A0x42bf71f8309fedec!2sAWRIM%20Secretariate!5e0!3m2!1sen!2smw!4v1615644813074!5m2!1sen!2smw" width="100%" height="350" style="border:0;" allowfullscreen="" loading="lazy"></iframe> -->

   <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2301.661894780881!2d33.78457921421449!3d-14.022846748773436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1921cd8d083430f1%3A0xd661619430cebeff!2sTeresian%20Siters!5e0!3m2!1sen!2smw!4v1615981441925!5m2!1sen!2smw" width="100%" height="350" style="border:0;" allowfullscreen="" loading="lazy"></iframe> 
</div>
</template>

<script> 
var GoogleMapsLoader = require('google-maps')
   
export default {
    props:[
        'notHeight',
        'notWidth',
        'gm_center',
        'gm_points',
        'gm_zoom'
    ],
    data(){
        return{  
            visible:true,
            newMap:{},
            malawi:{lat:-13.2543,lng:34.3015},
            lilongwe:{lat:-13.9626,lng:33.7741} 
        } 
    },
    mounted(){ 
    //    this.createMap()
      
    },
    created(){
         GoogleMapsLoader.KEY = 'AIzaSyDbbHjDYdjpEcmkO9e1el4g0h1vxLOAf_E'
    },
    computed:{ 
        mapHeight(){
            let h = this.notHeight
            if (!h) {
                return "height:100%; "
            } 
            return "height:"+h+";"
        },
        mapWidth(){
            let w = this.notWidth
            if (!w) {
                return "width:100%; "
            } 
            return "width:"+w+";"
        },
        mapZoom(){
            let z = this.gm_zoom
            if (!z) {
                return 8
            } 
            return parseInt(z)
        }, 
         
    },
    methods:{ 
        createMap(){
            let self = this
            let myMap = document.getElementById('myMap')
            let options={
                zoom:this.mapZoom,
                center:this.malawi
            } 
            GoogleMapsLoader.load(google=>{ 
                //new map
                let newMap=new google.maps.Map(myMap, options) 
                self.newMap = newMap
                //new marker
                this.addMarker(newMap)
                
            });
        },
        addMarker(map){
            let newMarker = new google.maps.Marker({
                position:this.lilongwe,
                map:map, 
            })
            this.addInfoWindow(map,newMarker,'<h1>test 2 map</h1>')
            return newMarker
        },
        addInfoWindow(map,marker,text){
            let infoWindow = new google.maps.InfoWindow({
                content:text
            })
            marker.addListener('click',()=>{
                infoWindow.open(map,marker)
            })
            return infoWindow
        },
        mapSize(){
            let h = this.mapHeight
            let w = this.mapWidth
            return h+w
        } 
    },
    watch:{
       
    } 
}
</script> 

